import React, { Fragment, Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../components/Layout/Header';
import Content from './Content';
import Footer from '../../components/Layout/Footer';
import WhatsApp from '../../components/Layout/Contato/Whatsapp';

export default class Comparatives extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <Fragment>
                <Helmet title={`Comparativos de imóveis | ${process.env.REACT_APP_NAME}`} />
                <Header />
                <main>
                    <Content />
                </main>
                <Footer />
                <WhatsApp />
            </Fragment>
        );
    }
}